import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { TextField } from '@mui/material';
import { IPets } from 'app/models/Placement/PlacementMods';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditPreferencePetsRows,
  selectPreferencePetsTypeError,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findIndex, findRow } from '../AdultGridComponents/AdultNameCell';
import { getDisplayValue } from '../utils';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const PetTypeCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <PetType cellParams={cellParams} />
    </>
  );
};

const PetType = React.memo(function PetType(cellParams: GridCellProps) {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  const editPreferencePetsRequests = useSelector(selectEditPreferencePetsRows);
  const preferencePetsTypeError = useSelector(selectPreferencePetsTypeError);

  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferencePetsRequests);
  const type = rowData?.type;
  const [petType, setPetType] = useState(type === '--' ? null : type);

  const setTypeForPetGridEdit = data => {
    let newRows = editPreferencePetsRequests.slice(0);
    let petsGridEditRow = findRow(editPreferencePetsRequests, RowId);

    let updatedType = {} as IPets;
    updatedType = {
      ...petsGridEditRow,
      type: data ? data.trim() : '',
    };
    let editTypeIndex = findIndex(editPreferencePetsRequests, RowId);
    newRows[editTypeIndex] = updatedType;
    dispatch(placementModsAction.setEditPetsRows(newRows));
  };
  //UPDATE THE ERROR
  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = preferencePetsTypeError?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = preferencePetsTypeError?.length > 0 ? preferencePetsTypeError.slice(0) : [];
        const valueObj = { type: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setPreferencePetsTypeError(arr));
      } else {
        const arr = preferencePetsTypeError?.slice(0);
        let currentObj = arr.find(v => v.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, type: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(v => v.id === cellParams?.cellParams?.id);
        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setPreferencePetsTypeError(arr));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellParams?.cellParams?.error]);

  return (
    <>
      <Controller
        name={`petsGrid${RowId}.type`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: '150px',
            }}
            value={petType}
            inputProps={{ maxLength: 255 }}
            onBlur={e => {
              setTypeForPetGridEdit(e.target.value);
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                setPetType(e.target.value);
                onChange(e.target.value);
              } else {
                setPetType('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
